import { ApiClientError } from './adminApi.js';
import { adminBasePath } from './base.js';
import type {
  InfluencerImportBatchDetail,
  InfluencerImportBatchListResponse,
  InfluencerImportExecuteInput,
  InfluencerImportPreview,
} from './types.js';

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const { headers, ...rest } = options ?? {};
  const requestHeaders = new Headers(headers);
  if (!requestHeaders.has('Accept')) {
    requestHeaders.set('Accept', 'application/json');
  }
  const response = await fetch(`${adminBasePath()}${path}`, {
    cache: 'no-store',
    ...rest,
    headers: requestHeaders,
  });
  const data = (await response.json().catch(() => ({}))) as Record<string, unknown>;
  if (!response.ok) {
    const message = typeof data.error === 'string' ? data.error : `HTTP ${response.status}`;
    throw new ApiClientError(message, response.status);
  }
  return data as T;
}

export function previewInfluencerImport(file: File, botWechatRecordId: number): Promise<InfluencerImportPreview> {
  return request<InfluencerImportPreview>(`/api/influencer-imports/preview?botWechatRecordId=${botWechatRecordId}`, {
    method: 'POST',
    headers: {
      'Content-Type': XLSX_MIME,
      'x-file-name': encodeURIComponent(file.name),
    },
    body: file,
  });
}

export function executeInfluencerImport(input: InfluencerImportExecuteInput): Promise<InfluencerImportBatchDetail> {
  return request<InfluencerImportBatchDetail>('/api/influencer-imports', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function listInfluencerImportBatches(limit = 20): Promise<InfluencerImportBatchListResponse> {
  return request<InfluencerImportBatchListResponse>(`/api/influencer-imports?limit=${limit}`);
}

export function getInfluencerImportBatch(batchId: number): Promise<InfluencerImportBatchDetail> {
  return request<InfluencerImportBatchDetail>(`/api/influencer-imports/${batchId}`);
}
